import api from '../utils/api';

const hrDevelopmentService = {
  onboarding: staffId => api.get('/api/hr/development/onboarding', { params: staffId ? { staff_id: staffId } : {} }),
  createOnboardingTask: data => api.post('/api/hr/development/onboarding', data),
  updateOnboardingTask: (id, data) => api.patch(`/api/hr/development/onboarding/${id}`, data),
  training: staffId => api.get('/api/hr/development/training', { params: staffId ? { staff_id: staffId } : {} }),
  createTraining: data => api.post('/api/hr/development/training', data),
  certifications: staffId => api.get('/api/hr/development/certifications', { params: staffId ? { staff_id: staffId } : {} }),
  expiringCertifications: (days = 30) => api.get('/api/hr/development/certifications/expiring', { params: { days } }),
  createCertification: data => api.post('/api/hr/development/certifications', data),
};

export default hrDevelopmentService;